document.addEventListener('alpine:init', () => {
  Alpine.data('BundleBuilder', () => ({
    bundle_variants: [],
    bundle_min: 3,
    bundle_max: 5,
    bundle_count: 0,
    flags: {
      is_complete: false
    },
    init() {
      this.InitWatchers();
    },
    InitWatchers() {
      this.$watch('bundle_variants', (value) => {
        let total_quantity = this.bundle_variants.reduce((sum, v) => sum + v.selected_quantity, 0);
        this.flags.is_complete = total_quantity >= this.bundle_min;
        this.bundle_count = total_quantity;
      });
    },
    e_BundleUpdated(e) {
      let variant = JSON.parse(e.currentTarget.dataset.variant);
      let $quantity = e.currentTarget.querySelector('.stay-ai-bundle-product__quantity');
      let quantity = $quantity.value;
      variant.selected_quantity = parseInt(quantity);
      // console.log('Bundle Updated:', variant);

      if (this.bundle_variants.some(v => v.id === variant.id)) {
        this.bundle_variants = [...this.bundle_variants.map(v => v.id === variant.id ? variant : v)];
      } 
      else {
        this.bundle_variants = [...this.bundle_variants, variant];
      }
      // console.log('Current Bundle Variants:', this.bundle_variants);
    },
    async e_BundleAddToCart(e) {
      console.log('Add Bundle to Cart:', this.bundle_variants);

      let $bundle = e.currentTarget.closest('.lsg-bundle-block')
      let $frequency_select = e.currentTarget.closest('.lsg-bundle-sticky-bar').querySelector('.lsg-bundle-interval-frequency-select');
      let is_subscription = $bundle.classList.contains('lsg-bundle--sub-selected');
      let selling_plan_id = is_subscription ? $frequency_select.value : null;

      let items = this.bundle_variants
        .filter(v => v.selected_quantity > 0)
        .map(v => {
          let variant_selling_plan = v.selling_plan_allocations.find(sp => sp.selling_plan_id == selling_plan_id);
          return {
            id: v.id,
            quantity: v.selected_quantity,
            selling_plan: variant_selling_plan ? selling_plan_id : null
          }
        });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: items
        })
      })
      .then(response => response.json())
      .then(data => {
        // console.log('Success:', data);

        // after adding reset
        this.$nextTick(this.ResetBundle.bind(this));
      });
    },
    ResetBundle() {
      document.querySelectorAll('[data-bundle-builder-selected-product-remove-button]').forEach(removeBtn => {
        removeBtn.click();
        setTimeout(() => {
          removeBtn.click();
        }, 50);
      });
      this.bundle_variants = [];
    },

    ShowSavingPercent(itemIndex) {
      let saving = '';
      switch(itemIndex) {
        case 2:
          saving = 'Save 5%';
          break;
        case 3:
          saving = 'Save 10%';
          break;
        case 4:
          saving = 'Save 15%';
          break;
        default:
          saving = '&nbsp;';
      }

      return saving;
    }
  }));
});